import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth, canAccessRoute, defaultHomePath } from '../context/AuthContext';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div className="page-loading">Loading…</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (!canAccessRoute(user, location.pathname)) {
    return <Navigate to={defaultHomePath(user)} replace />;
  }

  return children;
}

export default ProtectedRoute;
